import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Modal, Form, Select, Spin, Icon } from 'antd';
import { isEmpty, find, get } from 'lodash';

import { setData, getHubSurveys } from '../actions';

import '../index.scss';

const { Option } = Select;

class SurveyCreationModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalData: {
        hubId: undefined,
        surveyId: undefined,
      },
      showHubFilterConfirmModal: false,
    };
  }

  componentDidMount() {
    const {
      hubsSurveys,
      getHubSurveys,
      surveyData,
      singleTemplate = {},
    } = this.props;
    if (isEmpty(hubsSurveys)) getHubSurveys();
    if (!isEmpty(surveyData) && !singleTemplate.id) {
      const { hubId, surveyId } = surveyData;
      this.setState({ modalData: { hubId, surveyId } });
    } else {
      this.setState({ modalData: { hubId: undefined, surveyId: undefined } });
    }
  }

  componentDidUpdate(prevProps) {
    const { surveyData = {}, singleTemplate = {} } = this.props;
    const { surveyData: data } = prevProps;
    if (get(surveyData, 'surveyId') !== get(data, 'surveyId')) {
      if (!isEmpty(surveyData.surveyId) && !singleTemplate.id) {
        const { hubId, surveyId } = surveyData;
        this.setState({ modalData: { hubId, surveyId } });
      } else {
        this.setState({
          modalData: { hubId: undefined, surveyId: undefined },
        });
      }
    }
  }

  toggleModal = (submitCalled = false) => {
    const { setData, hubsSurveys, history, copyFromSurvey = false } = this.props;
    const { modalData } = this.state;
    const noRedirect = copyFromSurvey === true;
    if (submitCalled) {
      const [singleTemplate = {}] = (hubsSurveys &&
        find(hubsSurveys, { id: modalData.hubId }).surveys.filter(
            p => p.id === modalData.surveyId
        )) || [undefined];
      const { id, hubSpecificFilter, ...templateData } = singleTemplate;

      setData({
        surveyData: { ...modalData },
        showSurveyForm: true,
        showSurveyCreationModal: false,
        singleTemplate: templateData,
        preSelectedHubs: [],
        copyFromSurvey: false,
      });
      if (!noRedirect) {
        history.push('/survey-provisioning/create');
      }
      return;
    }
    setData({
      showSurveyCreationModal: false,
    });
  };

  confirmModal = () => this.setState({ showHubFilterConfirmModal: false });

  handleModalSelect = (type, val) => {
    const { modalData } = this.state;
    if(type === 'hubId') {
      this.setState({ modalData: { [type]: val, surveyId: undefined } });
    } else {
      this.setState({ modalData: { ...modalData, [type]: val } });
    }
  };

  render() {
    const { loading, hubsSurveys, showSurveyCreationModal } = this.props;
    const { modalData } = this.state;

    return (
      <>
        <Modal
          visible={showSurveyCreationModal}
          className="hubs_surveys_modal"
          title="Select Source Survey"
          destroyOnClose
          onCancel={() => this.toggleModal()}
          footer={[
            <Button key="cancel" onClick={() => this.toggleModal()}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              disabled={!modalData.hubId || !modalData.surveyId}
              onClick={() => this.toggleModal(true)}
            >
              Copy
            </Button>,
          ]}
        >
          {get(loading, 'survey_list', false) ? (
            <div style={{ textAlign: 'center' }}>
              <Spin
                tip="Fetching hubs and surveys"
                size="small"
                indicator={<Icon type="loading" spin />}
              />
            </div>
          ) : (
            <>
              <Form>
                <Form.Item name="hub" label="Select Hub" colon={false}>
                  <Select
                    placeholder="Select Hub"
                    onChange={event => this.handleModalSelect('hubId', event)}
                    value={modalData && modalData.hubId}
                  >
                    {hubsSurveys &&
                      hubsSurveys.map(hp => (
                        <Option value={hp.id}>
                          {hp.id} - {hp.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
                <Form.Item name="survey" label="Select Survey" colon={false}>
                  <Select
                    placeholder="Select Survey"
                    disabled={!modalData.hubId}
                    onChange={event =>
                      this.handleModalSelect('surveyId', event)
                    }
                    value={modalData && modalData.surveyId}
                  >
                    {hubsSurveys &&
                      modalData.hubId &&
                      find(hubsSurveys, {
                        id: modalData.hubId,
                      }).surveys.map(p => (
                        <Option value={p.id}>
                          {p.id} -{' '}
                          {p.title}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Form>
            </>
          )}
        </Modal>
      </>
    );
  }
}

const mapStateToProps = ({
  surveyProvisioningReducer: {
    hubsSurveys,
    showSurveyCreationModal,
    loading,
    surveyData,
    singleTemplate,
    copyFromSurvey,
  },
}) => ({
  hubsSurveys,
  showSurveyCreationModal,
  loading,
  surveyData,
  singleTemplate,
  copyFromSurvey,
});

const mapDispatchToProps = {
  setData,
  getHubSurveys,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SurveyCreationModal)
);
